// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2hXPd","empty":"ModalGraph_empty__eRocj"};